<template>
  <div class="el-stripe">
    <!-- Retentativa Offline - Cobranças -->
    <charge-attempt
      :title="$t('account.settings.charge-attempt.title')"
      :callback="saveChargeAttemptSettings"
      :loading="attemptLoading"
      :formIsInvalid="$v.chargeAttempt.$invalid"
      @cancelEdit="resetObject(chargeAttempt, attemptSettings)"
      :hideEditButton="!permissionIsEnabled('settings.charge_attempt:edit')"
      v-if="permissionIsEnabled('settings.charge_attempt:view')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.charge-attempt.config') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.charge-attempt.status-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status chargeAttempt -->
              <div class="emd-form-group">
                <label
                  class="emd-label"
                  for="status"
                  >{{ $t('account.settings.charge-attempt.status') }}</label
                >
                <span class="emd-input-helper"></span>
                <label
                  class="emd-switcher__label"
                  for="enableChargeAttempt"
                >
                  <input
                    class="emd-switcher _color_success"
                    type="checkbox"
                    id="enableChargeAttempt"
                    true-value="active"
                    false-value="inactive"
                    v-model="chargeAttempt.status"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">{{
                    $t('account.settings.charge-attempt.active')
                  }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.charge-attempt.intervals') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.charge-attempt.intervals-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Intervals chargeAttempt -->
              <div class="emd-form-group _condensed_50">
                <label
                  class="emd-label"
                  v-bind:class="{
                    _required: chargeAttempt.status === 'active'
                  }"
                  >{{
                    $t('account.settings.charge-attempt.interval-number')
                  }}</label
                >
                <ul
                  v-if="attemptIntervals.length > 0"
                  class="emd-list _space_base"
                >
                  <li
                    v-for="(interval, index) in attemptIntervals"
                    :key="index"
                  >
                    <div class="emd-input-group">
                      <input
                        type="number"
                        class="emd-input"
                        name="interval[]"
                        :max="maxAttempt"
                        v-model="interval.value"
                        @input="validateInterval(index, interval.value)"
                        v-bind:class="{ _state_error: sumOfAttempts > 7200 }"
                      />
                      <button
                        class="emd-btn _color_danger _type_text"
                        type="button"
                        v-on:click="removeInterval(index)"
                        v-if="
                          index !== 0 ||
                          (index === 0 && attemptIntervals.length > 1)
                        "
                      >
                        <i class="uil uil-minus-circle" />
                      </button>
                    </div>
                  </li>
                  <button
                    class="emd-btn _color_primary"
                    type="button"
                    v-on:click="addInterval()"
                    :disabled="
                      attemptIntervals.length > 5 ||
                      !attemptIntervals[attemptIntervals.length - 1].value ||
                      attemptIntervals[attemptIntervals.length - 1].value < 1
                    "
                  >
                    <i class="uil uil-plus" />
                    {{ $t('account.settings.charge-attempt.add-retry') }}
                  </button>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
    </charge-attempt>
  </div>
</template>
<script>
import ConfigBox from '@/components/project/molecules/ConfigBox.vue'
import { requiredIf } from 'vuelidate/lib/validators'
export default {
  name: 'Orders',
  components: {
    ChargeAttempt: ConfigBox
  },
  data () {
    return {
      chargeAttempt: {
        status: 'inactive',
        type: 'charge',
        intervals: []
      },
      attemptIntervals: []
    }
  },
  validations: {
    chargeAttempt: {
      status: {
        required: false
      },
      intervals: {
        required: requiredIf(function () {
          return this.chargeAttempt.status === 'active'
        })
      }
    }
  },
  computed: {
    attemptSettings: {
      get () {
        return this.$store.getters.attemptSettings
      }
    },
    attemptLoading () {
      return this.$store.getters.attemptLoading
    },
    accountLoading () {
      return this.$store.getters.accountLoading
    },
    params: function () {
      return {
        merchantId: this.$store.getters.merchantId,
        accountId: this.$store.getters.accountId
      }
    },
    sumOfAttempts () {
      let total = 0
      this.attemptIntervals.forEach(interval => {
        if (interval.value) total = total + parseInt(interval.value)
      })
      return total
    },
    maxAttempt () {
      return 7200 - this.sumOfAttempts
    }
  },
  methods: {
    saveChargeAttemptSettings (password) {
      const params = this.params
      this.chargeAttempt.password = password
      this.chargeAttempt.intervals = []
      this.attemptIntervals.forEach(interval =>
        this.chargeAttempt.intervals.push(parseInt(interval.value))
      )
      params.body = this.chargeAttempt

      if (this.chargeAttempt.id) {
        params.attemptId = this.chargeAttempt.id
        this.chargeAttempt.password = password
        return this.$store.dispatch('UPDATE_ATTEMPT_SETTINGS', params)
      } else if (
        !this.chargeAttempt.id &&
        this.chargeAttempt.status === 'active'
      ) {
        return this.$store.dispatch('CREATE_ATTEMPT_SETTINGS', params)
      } else if (!this.chargeAttempt.id) {
        return Promise.resolve(true)
      }
    },
    prepareIntervals (attempt) {
      this.attemptIntervals = []
      if (!attempt || (attempt && attempt.status === 'inactive')) {
        this.attemptIntervals = [
          {
            value: null
          }
        ]
      } else if (attempt && attempt.intervals.length) {
        attempt.intervals.forEach(interval => {
          this.attemptIntervals.push({ value: interval })
        })
      }
    },
    addInterval () {
      if (this.attemptIntervals.length < 6) {
        this.attemptIntervals.push({ value: null })
      }
    },
    removeInterval (index) {
      this.attemptIntervals.splice(index, 1)
    },
    validateInterval (index, value) {
      if (this.sumOfAttempts <= 7200) {
        this.refreshIntervals(index, value)
      } else {
        this.chargeAttempt.intervals = []
      }
    },
    refreshIntervals (index, value) {
      this.chargeAttempt.intervals = []
      this.attemptIntervals.forEach(interval => {
        if (interval.value)
          this.chargeAttempt.intervals.push(parseInt(interval.value))
      })
    },
    resetObject (obj, objFromApi) {
      const attempt = Object.assign(
        {
          status: 'inactive',
          type: 'charge',
          intervals: []
        },
        objFromApi.find(a => a.type === 'charge')
      )
      this.chargeAttempt.status = attempt.status
      this.prepareIntervals(attempt)
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  created () {
    this.$store.dispatch('GET_ACCOUNT', this.params)
    this.$store.dispatch('GET_ATTEMPT_SETTINGS', this.params).then(res => {
      this.chargeAttempt = Object.assign(
        this.chargeAttempt,
        this.attemptSettings.find(attempt => attempt.type === 'charge')
      )
      this.prepareIntervals(this.chargeAttempt)
    })
  }
}
</script>
